import { ITagArticles } from '@features/cms/typescript';
const getTagsFromUrl = (usedTags: ITagArticles[], setActiveTags: (tags: ITagArticles[]) => void) => {
  if (typeof window !== 'undefined') {
    const {
      search
    } = window.location;
    const params = new URLSearchParams(search);
    const tagsFromUrl = params.get('tags');
    const correctTagsFromUrl: ITagArticles[] = [];
    if (tagsFromUrl) {
      tagsFromUrl.split('-').forEach(tagFromUrl => {
        usedTags.forEach(tag => {
          if (tag.name === tagFromUrl && !correctTagsFromUrl.find(correctTag => correctTag.name === tagFromUrl)) correctTagsFromUrl.push(tag);
        });
      });
      setActiveTags(correctTagsFromUrl);
    }
  }
};
export default getTagsFromUrl;